import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { DsuAssessmentModel } from '../dsu-assessment-models/dsu-assessment.models';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class DsuAssessmentService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveDsuAssessment(dsuAssessment: DsuAssessmentModel) {

    const API_URL: string = environment.baseUrl + environment.apis.savedsuAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: dsuAssessment.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewDsuAssessment(viewid: number, status: string) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdsuAssessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboarding_id: viewid,
        updated_by_role:this.sessionStorageService.getCurrentUserRole() == 'DSU Manager' ?'DSU':this.sessionStorageService.getCurrentUserRole(),
        // status: this.sessionStorageService.getCurrentUserRole() == 'DSU Manager' ? status == 'DSU Initial Assessment'?'DSU Initial Assessment': 'DSU Final Assessment' : status,
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
